function startBackgroundVideo (video) {
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	const start = () => {
		const pending = video.play();
		const show = () => video.classList.add('is-playing');
		if (pending && typeof pending.then === 'function') pending.then(show).catch(() => {});
		else show();
	};

	if (document.readyState === 'complete') start();
	else window.addEventListener('load', start, { once: true });
}

export default function workHero () {
	document.querySelectorAll('.work-hero video.bg-media').forEach(startBackgroundVideo);
}
